import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";


// *********************************** Manage User ***********************************************
export const getViewUsers = async (data) => {
  return decryptData(
    await axios.get(
      `/getViewUsers?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getStatedropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getStatedropdownList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getDistrictdropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getDistrictdropdownList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getTalukadropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getTalukadropdownList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getUserRoledropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getUserRoledropdownList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addUser = async (data) => {
  return decryptData(
    await axios.post(`/addUser`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getUserListById = async (data) => {
  return decryptData(
    await axios.get(
      `/getUserListById?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const UpdateUser = async (data) => {
  return decryptData(
    await axios.post(`/UpdateUser`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const UpdateStatusofUser = async (data) => {
  return decryptData(
    await axios.post(`/UpdateStatusofUser`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};


// *************************************** Manage Roles **********************************************
export const getUserTypeList = async (data) => {
  return decryptData(
    await axios.get(
      `/getUserTypeList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const AddUserType = async (data) => {
  return decryptData(
    await axios.post(`/AddUserType`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getUserTypeListById = async (data) => {
  return decryptData(
    await axios.get(
      `/getUserTypeListById?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const UpdateUserType = async (data) => {
  return decryptData(
    await axios.post(`/UpdateUserType`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

